import React, { useState } from 'react';
import '../css/Header.css';
import { Link } from 'react-router-dom';
import logoFull from '../assets/callide-lockup-horizontal-light.svg';
import logoMark from '../assets/callide-mark-light.svg';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => setMenuOpen(false);

    return (
        <header className="header">
            <Link to="/" className="header-brand" onClick={closeMenu}>
                <img src={logoFull} alt="Callide" className="logo logo-full" />
                <img src={logoMark} alt="Callide" className="logo logo-mark" />
            </Link>
            <button
                className={`hamburger${menuOpen ? ' open' : ''}`}
                onClick={() => setMenuOpen(prev => !prev)}
                aria-label="Toggle navigation"
            >
                <span />
                <span />
                <span />
            </button>
            <nav className={menuOpen ? 'nav-open' : ''}>
                <ul className="nav-list">
                    <li><Link to="/" onClick={closeMenu}>Home</Link></li>
                    <li><Link to="/about" onClick={closeMenu}>About</Link></li>
                    <li><Link to="/testimonials" onClick={closeMenu}>Testimonials</Link></li>
                    <li><Link to="/contact" className="nav-cta" onClick={closeMenu}>Get Started</Link></li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;
